import {
  ArrayValidation,
  BooleanValidation,
  StringValidation,
} from '../../../utils/component-validations';
import Container from './container.gjs';
import Super from './base.gjs';
import styles from './helper-text.module.scss';

export default class SpdsCoreHelperText extends Super {
  arguments = [
    new ArrayValidation({ optional: ['errors'] }),
    new BooleanValidation({ optional: ['error'] }),
    new StringValidation({ optional: ['helperText'] }),
  ];
  baseClass = 'spds-helper-text';
  classesToMapToAttrs = ['error'];
  styles = styles;

  get error() {
    return this.args.error ?? this.errors.length > 0;
  }

  get errors() {
    return this.args.errors ?? [];
  }

  <template>
    <Container
      @column={{true}}
      @content={{@helperText}}
      class={{this.classes}}
      data-test-spds-helper-text
      id={{this.id}}
      {{this.validateArguments}}
      ...attributes
    >
      {{#if this.errors}}
        {{#each this.errors as |error index|}}
          <Container @content={{error}} data-test-spds-helper-text-error={{index}} />
        {{/each}}
      {{else}}
        {{yield}}
      {{/if}}
    </Container>
  </template>
}
